/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
/// <reference path="../../Controllers/plugin.d.ts"/>

import * as React from "react";

import { ControllerBase, PageStatusFlags } from "./ControllerBase";
import { DevPortalAppBase } from "../../DevPortalAppBase";
import * as Rest from "../../Generated/RestClient";
import { HeaderKind } from "../Utility/HeaderKind";
import { Environment } from "../../../../Intercom.ReactUI/Utils/Environment";
import logger from "../../../../Intercom.ReactUI/Utils/logger";
import * as Dialogs from "../../Dialogs/MessageBox";
import { ProgressDialog } from "../../Dialogs/ProgressDialog";
import { GenericDialog } from "../../Dialogs/GenericDialog";
import * as EmbedCodeView from "../Views/EmbedCodePanel";
import * as ChannelEnabledPanel from "../../Views/ChannelEnabledPanel";
import * as ChannelLogPanel from "../../Views/ChannelLogPanel";
import { BotProgress } from "../Views/index";
import { ChannelDataHandlers } from "../Views/BotChannels";
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";
import { clientAppSettings } from "../../Models/ClientAppSettings";

import { AuthenticationUtility } from "../Utility/AuthenticationUtility";

export class BotControllerBase extends ControllerBase {
    protected botId: string;
    protected channel: string;
    protected channelDataHandlers: ChannelDataHandlers;
    protected botSub: Rest.BotSubscription;

    constructor(app: DevPortalAppBase) {
        super(app);

        this.channelDataHandlers = {
            showEmbedHandler: (_lastFocus) => { this.showEmbedCodes(_lastFocus); },
            refreshChannelLogs: (bot: Rest.BotService) => {
                this.getBotLogs(bot.Id).done(() => {
                    if (this.botSub) {
                        this.botSub.Bot = bot;
                        this.saveBotStateAndRender(this.botSub);
                    }
                });
            },
            channelLogs: null,
            channelStateChangeHandler: (column, id, isOn) => this.onChannelStateChangeRequested(column, id, isOn),
            channelEnabledDisplayHandler: (channelEnabledDisplay: ChannelEnabledPanel.ChannelEnabledPanelProps) => this.showChannelEnabledPanel(channelEnabledDisplay),
            channelLogDisplayHandler: (channelLogDisplay: ChannelLogPanel.ChannelLogPanelProps) => this.showChannelLogPanel(channelLogDisplay),
            getChannelPublishStatus: (channelId: string) => null,
        };
    }

    protected saveBotStateAndRender(botSub: Rest.BotSubscription) {
        throw new Error("saveBotStateAndRender needs an override");
    }

    protected getBotLogs(botId: string) {
        return Rest.BotManagerClient.getBotLogs(botId).done(logs => {
            this.channelDataHandlers.channelLogs = logs;
        }).fail((jqXHR: JQueryXHR, textStatus, errorThrown) => {
            this.handleHttpResponseError(jqXHR);
        });
    }

    protected onChannelStateChangeRequested(column: string, channelId: string, enable: boolean): void {
        if (column === "listed") {
            Rest.BotManagerClient.listChannelForBot(this.botId, channelId, enable).done(bot => {

                this.getBotLogs(bot.Id);

            }).fail(xhr => {
                this.handleHttpResponseError(xhr);
            });
        }
        if (column === "enabled") {
            Rest.BotManagerClient.enableChannelForBot(this.botId, channelId, enable).done(bot => {

                this.getBotLogs(bot.Id);

            }).fail(xhr => {
                this.handleHttpResponseError(xhr);
            });
        }
    }

    protected showEmbedCodes(_lastFocus?: React.ReactInstance): void {
        const progressDialog = ProgressDialog.show(Resources.embedPanelGettingCodes);
        Rest.BotManagerClient.getBotContactCard(this.botId).done(contactCard => {
            progressDialog.closeDialog();
            if (!contactCard.Contacts.length) {
                Dialogs.MessageBox.show(Resources.embedPanelNoCodeAvailable);
            }
            else {
                const dialog = new GenericDialog<EmbedCodeView.EmbedCodePanelProps>(EmbedCodeView.EmbedCodePanel, {
                    botId: this.botId,
                    contacts: contactCard.Contacts
                }, { dialogClass: 'embed-code-dialog' });
                dialog.showDialog(_lastFocus);
            }
        }).fail(xhr => {
            progressDialog.closeDialog();
            this.handleHttpResponseError(xhr);
        });
    }

    protected showChannelEnabledPanel(channelEnabledDisplay: ChannelEnabledPanel.ChannelEnabledPanelProps): void {
        const dialog = new GenericDialog<ChannelEnabledPanel.ChannelEnabledPanelProps>(ChannelEnabledPanel.ChannelEnabledPanel, channelEnabledDisplay, { dialogClass: 'status-panel-dialog' });
        dialog.showDialog();
    }

    protected showChannelLogPanel(channelLogDisplay: ChannelLogPanel.ChannelLogPanelProps): void {
        const dialog = new GenericDialog<ChannelLogPanel.ChannelLogPanelProps>(ChannelLogPanel.ChannelLogPanel, channelLogDisplay, { dialogClass: 'channellog-dialog' });
        channelLogDisplay.dialog = dialog;
        dialog.showDialog();
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Controllers/BotControllerBase.ts